export type PlatformViewportStateValues = {
  width: number;
  height: number;
};

export interface IPlatformViewportState {
  values: PlatformViewportStateValues;
  updateValues: (newValues: Partial<PlatformViewportStateValues>) => void;
  registerObserver: (observer: () => void) => void;
  unregisterObserver: (observer: () => void) => void;
}

export class PlatformViewportState implements IPlatformViewportState {
  private observers: ((values: PlatformViewportStateValues) => void)[];

  public values: PlatformViewportStateValues;

  constructor(values?: PlatformViewportStateValues) {
    this.values = values || {
      width: 0,
      height: 0,
    };
    this.observers = [];
  }

  public updateValues(newValues: Partial<PlatformViewportStateValues>) {
    this.values = {...this.values, ...newValues};
    // eslint-disable-next-line no-restricted-syntax
    for (const observer of this.observers) {
      observer(this.values);
    }
  }

  public registerObserver(observer: () => void) {
    this.observers.push(observer);
  }

  public unregisterObserver(observer: () => void) {
    this.observers = this.observers.filter((o) => o !== observer);
  }
}
